const sharedModule = {
  namespaced: true,
  state() {
    return {
      isLoading: false,
      unreadNotifications: 0,
      selectedTemplate: null,
    };
  },
  mutations: {
    updateIsLoading(state, isLoading) {
      state.isLoading = isLoading;
    },
    updateUnreadNotifications(state, unreadNotifications) {
      state.unreadNotifications = unreadNotifications;
    },
    setSelectedTemplate(state, template) {
      state.selectedTemplate = template;
    },
    clearSelectedTemplate(state) {
      state.selectedTemplate = null;
    },
  },
  getters: {
    getSelectedTemplate(state) {
      return state.selectedTemplate;
    },
  },
};

export default sharedModule;
